import {
   ChangeDetectionStrategy,
   Component,
   Inject,
   OnDestroy,
   OnInit,
   ViewChild,
   ViewEncapsulation,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { AddBlockedPhoneNumberData } from '../models/add-blocked-phone-number-data';
import { BlockedPhoneNumberDetailFormService } from '../services/blocked-phone-number-detail-form.service';
import {
   createBlockedPhoneNumber,
   createBlockedPhoneNumberAndAddAnother,
} from '../state/add-blocked-phone-number.actions';
import { getAddBlockedPhoneNumberCallState } from '../state/add-blocked-phone-number.selectors';
import { AddBlockedPhoneNumberViewComponent } from '../views/add-blocked-phone-number-view.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [BlockedPhoneNumberDetailFormService],
    selector: 'ndt-add-blocked-phone-number',
    styleUrls: ['./add-blocked-phone-number.component.scss'],
    templateUrl: './add-blocked-phone-number.component.html',
    standalone: false
})
export class AddBlockedPhoneNumberComponent implements OnInit, OnDestroy, FormComponent {
   @ViewChild(AddBlockedPhoneNumberViewComponent)
   AddBlockedPhoneNumberViewComponent: AddBlockedPhoneNumberViewComponent;

   callState: Observable<CallState>;

   form: UntypedFormGroup;

   private destroyed$ = new Subject<void>();

   constructor(
      protected store: Store,
      protected formService: BlockedPhoneNumberDetailFormService,
      protected router: Router,
      @Inject(MAT_DIALOG_DATA) public data: AddBlockedPhoneNumberData,
      private dialogService: LcsDialogService
   ) {
      this.callState = this.store.pipe(select(getAddBlockedPhoneNumberCallState));
   }

   ngOnInit(): void {
      this.form = this.formService.form;
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   onCloseClick(): void {
      this.dialogService.close();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.store.dispatch(
            createBlockedPhoneNumber({
               blockedPhoneNumber: this.formService.getValue(null),
            })
         );
      }
   }

   onCreateAndAddAnother(): void {
      if (this.form.valid) {
         this.store.dispatch(
            createBlockedPhoneNumberAndAddAnother({
               blockedPhoneNumber: this.formService.getValue(null),
            })
         );
      }
   }
}
